import { RootState } from "@/store/store";
import { ProviderConnectionsState } from "@/store/provider-connections/providerConnectionsSlice";

export const providerConnectionsStateSelector = (
  state: RootState,
): ProviderConnectionsState => {
  return state.providerConnections;
};
